<template>
  <div>
    <fragment v-if="results">
      <h2>Info</h2>
      <ul>
        <li>User Id: {{ results.userId }}</li>
        <li>Display Name: {{ results.displayName }}</li>
      </ul>
      <img :src="results.pictureUrl" width="72" alt="" />
    </fragment>

    <h2 class="mt-10">Sitemaps</h2>
    <ul>
      <li v-for="item in sitemaps" :key="item.key">
        <router-link :to="item.val">{{ item.key }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import liff from '@line/liff'

export default {
  data() {
    return {
      sitemaps: Object.entries(this.$routePage).map(([key, val]) => ({ key, val })),
      results: null,
    }
  },
  async created() {
    if (liff.isLoggedIn()) {
      this.results = await liff.getProfile()
    }
  },
  computed: {
    shopName() {
      return this.$store.getters['auth/getShopName']
    },
  },
  metaInfo() {
    return {
      title: this.$t('siteMaps.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('siteMaps.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('siteMaps.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>
